import { Filter } from '@cubejs-client/core';
import { useCubeQuery } from '@cubejs-client/react';
import { formatNumber, NumberFormatPreset, QuickViewWidget, useScrollIntoView } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { useModuleContext } from '~/components/ModuleContextProvider';

const formatValueCompact = formatNumber(NumberFormatPreset.INTEGER_COMPACT);
const formatValue = formatNumber(NumberFormatPreset.INTEGER);

export const PurchaseOrderEmissionWidget = () => {
  const { entityId } = useModuleContext();
  const { t } = useTranslation(I18nNamespace.widgets, {
    keyPrefix: 'PurchaseOrderEmissionWidget',
  });
  const [widgetRef, active] = useScrollIntoView({ hash: 'PurchaseOrderEmissionWidget' });

  const cube = 'EmissionsByOrder';

  const filters: Filter[] = [
    {
      member: `${cube}.purchaseOrderId`,
      operator: 'equals',
      values: [entityId],
    },
  ];

  const queryValue = useCubeQuery({
    dimensions: [`${cube}.emissionValue`],
    filters,
  });

  const value = (queryValue.resultSet?.rawData()?.[0]?.[`${cube}.emissionValue`] as number) ?? 0;

  return (
    <QuickViewWidget
      ref={widgetRef}
      active={active}
      loading={queryValue.isLoading}
      title={t('title')}
      subTitle={t('subTitle')}
      value={formatValueCompact(value)}
      valueTooltip={formatValue(value)}
      data-intercom-target={'PurchaseOrderEmissionWidget'}
    />
  );
};
